import useRouter from '~/client/hooks/router/useRouter';
import useSite from '~/client/hooks/useSite';

type Args = { title?: string };

const useSocialLinks = ({ title }: Args) => {
  const router = useRouter();
  const { siteConfig } = useSite();
  const url = `https://${siteConfig.domain}${router?.asPath}`;
  const mailTo = `mailto:?subject=${title}&body=${url}`;

  return { url, mailTo };
};

export default useSocialLinks;
